module.exports = __webpack_public_path__ + "img/comming_soon.655aaca5.png";